import data from '../codigosMexico.json'

export const obtenerProvincia = (estado) => {

    if (!estado) {

        return []
    }

    let estados = data.filter(item => item.state === estado);

    let set = new Set(estados.map(e => e.province));

    return [...set].sort()

}